import { render, staticRenderFns } from "./ViewSubmission.vue?vue&type=template&id=418bc81d&scoped=true"
import script from "./ViewSubmission.vue?vue&type=script&lang=js"
export * from "./ViewSubmission.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ViewSubmission.vue?vue&type=style&index=1&id=418bc81d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418bc81d",
  null
  
)

export default component.exports